// extracted by mini-css-extract-plugin
export var authors = "article-header-infinite-module--authors--+dUO4";
export var avatar = "article-header-infinite-module--avatar--SkHC9";
export var avatarImg = "article-header-infinite-module--avatarImg--RYFey";
export var avatars = "article-header-infinite-module--avatars--eU3xf";
export var breadcrumb = "article-header-infinite-module--breadcrumb--0ypFF";
export var breadcrumb_link = "article-header-infinite-module--breadcrumb_link--avuql";
export var dateBlock = "article-header-infinite-module--dateBlock--822Fz";
export var hero = "article-header-infinite-module--hero--xcpbZ";
export var mediaBody = "article-header-infinite-module--mediaBody--p-B1p";
export var pageHeader = "article-header-infinite-module--pageHeader--1ZNdB";
export var pageSubHeader = "article-header-infinite-module--pageSubHeader--do4uK";
export var svg1 = "article-header-infinite-module--svg1--u3JsP";
export var svg2 = "article-header-infinite-module--svg2--Kh2UT";
export var title = "article-header-infinite-module--title--yNJNO";